import httpClientService from '@/services/httpClientService';

export default {
	// Background exports (current endpoints)
	downloadGridView: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/Export/GridView',
			payload
		),
	downloadInventoryForm: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/Export/InventoryForm',
			payload
		),
	downloadReport: (item) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/Report`,
			item
		),
	downloadReportBackground: (item) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/Report`,
			item
		),
	downloadReportPreview: (reportId, payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/ReportPreview/${reportId}`,
			payload
		),
	downloadWorkbook: (item) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/Workbook`,
			item
		),
	downloadGridViewEntityHistory: (payload, rawData) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/GridViewEntityHistory?rawData=${rawData}`,
			payload
		),
	downloadGridViewEntityPerUserHistory: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/GridViewEntityPerUserHistory`,
			payload
		),
	downloadActivity: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/ActivityData/${payload.ActivityId}`,
			payload
		),
	downloadDetailedActivity: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/ActivityDetailedData/${payload.ActivityId}`,
			payload
		),
	downloadWorkbookPreview: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/Export/WorkbookPreview`,
			payload
		),
	downloadDataExports: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/Export/DataExports',
			payload
		),

	// Direct exports (new immediate download endpoints)
	downloadGridViewDirect: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/DirectExport/GridView',
			payload
		),
	downloadInventoryFormDirect: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/DirectExport/InventoryForm',
			payload
		),
	downloadReportDirect: (item) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/Report`,
			item
		),
	downloadReportPreviewDirect: (reportId, payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/ReportPreview/${reportId}`,
			payload
		),
	downloadWorkbookDirect: (item) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/Workbook`,
			item
		),
	downloadGridViewEntityHistoryDirect: (payload, rawData) => {
		const url = `/DataExportModule/api/DirectExport/GridViewEntityHistory?rawData=${rawData}`;
		return httpClientService.PostForExport(url, payload);
	},
	downloadGridViewEntityPerUserHistoryDirect: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/GridViewEntityPerUserHistory`,
			payload
		),
	downloadActivityDirect: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/ActivityData/${payload.ActivityId}`,
			payload
		),
	downloadDetailedActivityDirect: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/ActivityDetailedData/${payload.ActivityId}`,
			payload
		),
	downloadWorkbookPreviewDirect: (payload) =>
		httpClientService.PostForExport(
			`/DataExportModule/api/DirectExport/WorkbookPreview`,
			payload
		),
	downloadDataExportsDirect: (payload) =>
		httpClientService.PostForExport(
			'/DataExportModule/api/DirectExport/DataExports',
			payload
		),

	loadDataExportsReports: () =>
		httpClientService.Get('/DataExportModule/api/DataExports'),
	downloadFile: (fileId) =>
		httpClientService.GetForDownload(
			`/UserContextModule/api/File/${fileId}`
		),
};
